import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

/** 云盘 volume 配置（回收策略等）；dc/ws 由 URL 解析 */
export function getVolumeConfigs(): Promise<unknown> {
  return get(`${PREFIX.vapis_v1_dc_ws(GROUPS.computing)}/all-types`);
}
